<script setup lang="ts">
import type { CheckboxGroupValueType, CheckboxValueType } from 'element-plus';

interface OptionsParams {
  label: string;
  value: string;
}

interface Props {
  options?: OptionsParams[],
  label?: string,
  hint?: string,
  disabled?: boolean,
  required?: boolean,
  buttonClassName?: string,
  groupClassName?: string,
  columns?: 1 | 2,
}
export interface  Emits {
  change: [value: CheckboxValueType[]]
};

const props = withDefaults(defineProps<Props>(), {
  options: () => [],
  label: '',
  hint: '',
  disabled: false,
  required: false,
  buttonClassName: '',
  groupClassName: '',
  columns: 1,
});
const emit = defineEmits<Emits>();

const modelValue = defineModel<CheckboxGroupValueType>();

function handleChange(value: CheckboxValueType[]) {
  emit('change', value);
}
</script>

<template>
  <div
    class="ui-checkbox-group t:space-y-8"
    :class="{ 't:w-full': columns === 2 }"
  >
    <UiLabel
      v-if="label"
      :disabled="disabled"
      :label="label"
      :hint="hint"
      :required="required"
    />
    <ElCheckboxGroup
      v-model="modelValue"
      class="ui-checkbox-group__checkbox-group t:items-center"
      :class="[
        columns === 2
          ? 'ui-checkbox-group__checkbox-group_columns-2'
          : 't:flex t:space-x-16',
        groupClassName,
      ]"
      :disabled="disabled"
      @change="handleChange"
    >
      <slot name="checkbox">
        <UiCheckbox
          v-for="opt in options"
          :key="opt.value"
          is-group
          :value="opt.value"
          :label="opt.label"
          :class="[buttonClassName]"
        />
      </slot>
    </ElCheckboxGroup>
    <slot />
  </div>
</template>

<style lang="scss">
.ui-checkbox-group__checkbox-group_columns-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 30px;
}
</style>
